import { create } from 'zustand'
import { handleLocalStorage } from 'shared/helpers/handleLocalStorage'
import { SELECTED_BRANCH_ID } from './types'
import { GET } from 'shared/api/GET'
import { useGlobalStore } from './globalSlice'
import { POST } from 'shared/api/POST'
import { useLoadingStore } from './toasterSlice'
import { consoleError } from 'shared/helpers/consoleError'
import { useConfigStore } from './configSlice'

const getInitialBranchStore = () => {
  const branchIdLS = handleLocalStorage(SELECTED_BRANCH_ID)

  return {
    branchList: [],
    isBranchesLoading: false,
    branchId: branchIdLS || 0,
    clientIdSelected: 0
  }
}

export const useBranchStore = create<IBranchStore>(set => ({
  ...getInitialBranchStore(),
  getBranchList: async () => {
    set(state => {
      return {
        ...state,
        isBranchesLoading: true
      }
    })
    try {
      const loadConfig = useConfigStore.getState().loadConfig
      const { isCCSelected } = useGlobalStore.getState()
      const branchList = await GET.branches(!isCCSelected)
      const branchIdLS = handleLocalStorage(SELECTED_BRANCH_ID)
      const firstIdInList = branchList?.[0]?.Intern
      const clientIdSelected = (function () {
        switch (typeof branchIdLS) {
          case 'number':
            const branch = branchList?.find(el => el.Intern === branchIdLS)
            return branch?.QRMenuClientId || branch?.ClickAndCollectClientId
          case 'undefined':
            return branchList?.[0]?.QRMenuClientId || branchList?.[0]?.ClickAndCollectClientId
        }
      })()
      const getBranchToSet = (clientId?: number, branchId?: number) => {
        switch (true) {
          case Boolean(clientId && branchId):
            return branchIdLS
          case !clientId || !branchId:
          default:
            return firstIdInList
        }
      }
      const branchIdToSet = getBranchToSet(clientIdSelected, branchIdLS)
      if ((!branchIdLS || !clientIdSelected) && firstIdInList) {
        handleLocalStorage({ SELECTED_BRANCH_ID: firstIdInList })
        loadConfig(firstIdInList)
      }
      set(state => {
        return {
          ...state,
          branchId: branchIdToSet,
          branchList: branchList || [],
          clientIdSelected
        }
      })
    } catch (error) {
      consoleError(error)
    } finally {
      set(state => {
        return {
          ...state,
          isBranchesLoading: false
        }
      })
    }
  },
  updateBranch: async payload => {
    const { startLoading, finishWithSuccess, finishWithError } = useLoadingStore.getState()
    try {
      startLoading()
      const res = await POST.updateAddress(payload)
      set(state => {
        return {
          ...state,
          branchList: state.branchList?.map(branch => {
            if (branch.QRMenuClientId === res.QRMenuClientId) {
              return { ...branch, ...res }
            }
            return branch
          })
        }
      })
      finishWithSuccess()
    } catch (error) {
      consoleError(error)
      finishWithError()
    }
  },
  changeBranchId: newValue => {
    const loadConfig = useConfigStore.getState().loadConfig
    if (newValue) {
      handleLocalStorage({ SELECTED_BRANCH_ID: newValue })
      loadConfig(newValue)
    }
    set(state => {
      return {
        ...state,
        branchId: newValue
      }
    })
  }
}))

export interface IBranchStore {
  branchId: number
  clientIdSelected: number
  branchList: BranchType[]
  isBranchesLoading: boolean
  getBranchList: () => void
  updateBranch: (payload: Partial<BranchType>) => void
  changeBranchId: (value: number) => void
}

export type BranchType = {
  Bezeichnung: string
  Intern: number
  QRMenuClientId?: number
  ClickAndCollectClientId?: number
  Country: '1' | '2'
  Mail: string
  Phone: string
  Street: string
  Town: string
  Website: string
  ZipCode: string
  GoogleMapURL: string
  restaurantDesignId?: string
}
